export const VISIBILITY_STATUS = {
    HIDDEN: 'hidden',
    VISIBLE: 'visible',
    VISIBLE_IN_CRM: 'visible_in_crm',
    HIDDEN_IN_CRM: 'hidden_in_crm'
};